import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center px-4 py-24 text-center md:px-8">
        <p className="font-heading text-7xl font-black text-primary-200 select-none md:text-9xl">
          404
        </p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
          页面走丢了
        </h1>
        <p className="mt-2 text-sm text-foreground-500">
          你访问的页面不存在或已下线，不妨去看看正在热映的影片。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/movies"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            浏览电影分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}